import React, { useState, useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import { List, Button } from 'antd';
import { api, apis, ProductAuthorityFeature, apiHolder } from 'api';
import { comIsShowByAuth } from '@web-common/utils/utils';
import classnames from 'classnames';
import './index.scss';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { inWindow } from 'api';
import { getIn18Text } from 'api';
import MailReadList from './popover-read-list';
import { useContactModel } from '@web-common/hooks/useContactModel';
import styles from './index.module.scss';
const StatusItem = props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { item, isReadStatus, wordSeparator, isLoadingReadList, allReadList, modifiedTime, _account, forbid = false } = props;
    const model = useContactModel({ contactId: (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contactId, email: item.email || ((_b = item === null || item === void 0 ? void 0 : item.contact) === null || _b === void 0 ? void 0 : _b.accountName), name: item.contactName, _account });
    const contactName = ((_c = model === null || model === void 0 ? void 0 : model.contact) === null || _c === void 0 ? void 0 : _c.contactName) || (item === null || item === void 0 ? void 0 : item.contactName);
    const email = (item === null || item === void 0 ? void 0 : item.contact) ? contactApi.doGetModelDisplayEmail(item.contact) : item.email;
    let { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const readList = useMemo(() => {
        return allReadList && allReadList.length ? allReadList.filter(readItem => readItem.toAddr === email) : [];
    }, [allReadList]);
    const hasReadList = useMemo(() => {
        const isRead = item.status && item.status === 'read' ? true : false;
        if (item.result && item.result === 109 && isRead) {
            if (productVersionId === 'sirius') {
                return true;
            }
            else if (productVersionId == 'ultimate' && (readList === null || readList === void 0 ? void 0 : readList.length)) {
                const list = readList.filter(item => item.inner);
                return list && list.length > 0;
            }
        }
        return false;
    }, [item, productVersionId, readList]);
    return (React.createElement("div", { className: styles.rclListWrap },
        React.createElement("div", { className: styles.list },
            React.createElement("div", { className: styles.leftWrap },
                React.createElement("div", { className: styles.logoWrap },
                    React.createElement(AvatarTag, { style: { marginRight: '8px', marginLeft: '0px' }, size: 40, contactId: (_e = (_d = item === null || item === void 0 ? void 0 : item.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.id, propEmail: item.email || ((_f = item === null || item === void 0 ? void 0 : item.contact) === null || _f === void 0 ? void 0 : _f.accountName), user: {
                            name: (_h = (_g = item === null || item === void 0 ? void 0 : item.contact) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.contactName,
                            avatar: (_k = (_j = item === null || item === void 0 ? void 0 : item.contact) === null || _j === void 0 ? void 0 : _j.contact) === null || _k === void 0 ? void 0 : _k.avatar,
                            color: (_m = (_l = item === null || item === void 0 ? void 0 : item.contact) === null || _l === void 0 ? void 0 : _l.contact) === null || _m === void 0 ? void 0 : _m.color,
                        } }))),
            React.createElement("div", { className: styles.contentWrap },
                React.createElement("div", { className: styles.head },
                    React.createElement("div", { className: styles.title },
                        React.createElement("span", { className: styles.name, title: contactName }, contactName),
                        React.createElement("span", { className: styles.email, title: email }, email)),
                    React.createElement("div", { className: styles.status },
                        React.createElement("div", { className: classnames(['u-item-status', item.status == 'suc' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9 ? 'u-suc' : '']), style: { color: item.color, userSelect: hasReadList ? 'none' : 'auto' } }, item.status == 'suc'
                            ? getIn18Text('CHEHUICHENGGONG') + wordSeparator
                            : item.status == 'fail' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9
                                ? getIn18Text('CHEHUISHIBAI') + wordSeparator
                                : item.text))),
                isReadStatus && readList && readList.length ? (React.createElement("div", { className: styles.listWarp },
                    React.createElement(MailReadList, { isLoadingReadList: isLoadingReadList, item: item, forbid: forbid, readList: readList }))) : (React.createElement(React.Fragment, null))))));
};
const systemApi = apiHolder.api.getSystemApi();
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const StatusModal = ({ visible, readListData, refreshData, onClose, onUpgradeModel, onProductModal, tid, account, forbid }) => {
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const timeZone = mailConfApi.getTimezone();
    const [allReadList, setAllReadList] = useState([]);
    const [isLoadingReadList, setIsLoadingReadList] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);
    const loadReadList = () => {
        if (tid) {
            setIsLoadingReadList(true);
            setIsRefresh(true);
            mailApi.getMailReadList(tid, account).then(res => {
                if (!res.success) {
                    setAllReadList([]);
                }
                else {
                    setAllReadList(res.data || []);
                }
                setIsLoadingReadList(false);
                setTimeout(() => {
                    setIsRefresh(false);
                }, 1000);
            });
        }
    };
    useEffect(() => {
        loadReadList();
    }, [tid]);
    const [tabIndex, setTabIndex] = useState(0);
    const [tabList, setTabList] = useState([]);
    const [listData, setListData] = useState();
    const [status, setStatus] = useState();
    const isReadStatus = (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) ? false : true;
    const wordSeparator = inWindow() && window.systemLang === 'en' ? ' ' : '';
    const UnpermissionEle = () => {
        return (React.createElement("div", { className: "u-status-list-unPermission" },
            React.createElement("div", { className: "icon" }),
            React.createElement("div", { className: "content" },
                React.createElement("span", null, getIn18Text('SHENGJIFUWUTAO')),
                React.createElement("span", { className: "u-status-learn", onClick: onProductModal }, getIn18Text('LEJIEFUWUTAO'))),
            comIsShowByAuth(ProductAuthorityFeature.ADMIN_SITE_ENTRANCE_SHOW, React.createElement(Button, { type: "primary", onClick: onUpgradeModel }, getIn18Text('LIJISHENGJI')))));
    };
    const ListEle = () => {
        return (React.createElement(List, { itemLayout: "horizontal", header: status == 'unkown'
                ?
                    null
                : (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) && status !== 'fail'
                    ? getIn18Text('CHEHUICHENGGONGHOU')
                    : '', dataSource: listData, locale: {
                emptyText: (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "u-status-empty-img" }),
                    getIn18Text('MEIYOUNEIRONG'))),
            }, renderItem: item => {
                const modifiedTime = dayjs(systemApi.getDateByTimeZone(item.modifiedTime, timeZone, true)).format('YYYY-MM-DD HH:mm:ss');
                const email = (item === null || item === void 0 ? void 0 : item.contact) ? contactApi.doGetModelDisplayEmail(item.contact) : item.email;
                return (React.createElement(StatusItem, { item: item, modifiedTime: modifiedTime, isReadStatus: isReadStatus, wordSeparator: wordSeparator, isLoadingReadList: isLoadingReadList, allReadList: allReadList, _account: account, forbid: forbid }));
            } }));
    };
    const RenderEle = () => {
        if (productVersionId === 'sirius') {
            return ListEle();
        }
        if (status === 'unkown' || status === 'fail' || !status) {
            return ListEle();
        }
        else {
            if (productVersionId === 'free') {
                return UnpermissionEle();
            }
            else {
                return ListEle();
            }
        }
    };
    const ResetListHeight = () => {
        if (productVersionId === 'sirius') {
            return '350px';
        }
        if (status === 'read' || status === 'unread') {
            return '350px';
        }
        return '300px';
    };
    const handleStatusChange = index => {
        setTabIndex(index);
        if (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) {
            setStatus(['', 'suc', 'fail'][index]);
        }
        else {
            setStatus(['', 'read', 'unread', 'unkown'][index]);
        }
    };
    useEffect(() => {
        var _a;
        if (!status) {
            setListData(readListData === null || readListData === void 0 ? void 0 : readListData.data);
            return;
        }
        const _listData = (_a = readListData === null || readListData === void 0 ? void 0 : readListData.data) === null || _a === void 0 ? void 0 : _a.filter(item => {
            if (status === 'fail') {
                return item.status === status || item.status === 'unkown';
            }
            if (status === 'unkown') {
                return item.status === status || item.status === 'outdomain';
            }
            return item.status === status;
        });
        setListData(_listData);
    }, [status]);
    useEffect(() => {
        if (productVersionId === 'free') {
            handleStatusChange(3);
        }
    }, [productVersionId]);
    useEffect(() => {
        var _a;
        const sucList = [];
        const failList = [];
        const readList = [];
        const unreadList = [];
        const unkownList = [];
        if (readListData) {
            setListData(readListData.data);
            if ((_a = readListData.data) === null || _a === void 0 ? void 0 : _a.length) {
                readListData.data.forEach(item => {
                    if (item.status == 'suc') {
                        sucList.push(item);
                    }
                    else if (item.status == 'fail') {
                        failList.push(item);
                    }
                    else if (item.status == 'read') {
                        readList.push(item);
                    }
                    else if (item.status == 'unread') {
                        unreadList.push(item);
                    }
                    else {
                        unkownList.push(item);
                    }
                });
            }
            if (readListData.isrcl) {
                setTabList([getIn18Text('QUANBU'), `撤回成功(${sucList.length})`, `撤回失败(${failList.length})`]);
            }
            else {
                setTabList([
                    getIn18Text('QUANBU'),
                    `${getIn18Text('YIDU')}(${readList.length})`,
                    `${getIn18Text('WEIDU')}(${unreadList.length})`,
                    `${getIn18Text('WEIZHI')}(${unkownList.length})`,
                ]);
            }
        }
    }, [readListData]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "u-status", style: { paddingTop: '0' } },
            React.createElement("div", { className: "u-status-list sirius-scroll", style: { height: 'auto', maxHeight: 360 } }, RenderEle()))));
};
export default StatusModal;
